export default __webpack_public_path__ + "static/media/yellow-candy.9f32582f.png";